import { baseApi } from "./apiConfig";

export const fetchCmsDataForNodes = async (node) => {
  try {
    const response = await baseApi.get(
      `portal/get-new-cms-data/hubzuweb?template=/hubzuweb/${node}`
    );

    if (!response?.data) {
      console.warn(`No data returned for node: ${node}`);
      return { [node]: null };
    }

    return { [node]: response.data };
  } catch (error) {
    console.error(`Error fetching CMS data for node ${node}:`, error);

    // Handle specific error cases
    if (error.response) {
      // Server responded with error status
      switch (error.response.status) {
        case 404:
          console.warn(`CMS node ${node} not found`);
          break;
        case 403:
          console.warn(`Access forbidden for CMS node ${node}`);
          break;
        case 500:
          console.error(`Server error while fetching CMS node ${node}`);
          break;
        default:
          console.error(`HTTP error ${error.response.status} for node ${node}`);
      }
    } else if (error.request) {
      // Request made but no response received
      console.error("Network error while fetching CMS data");
    }

    // Return safe fallback
    return { [node]: null };
  }
};

// export const fetchCmsDataForNodes = async (nodes) => {
//   const requests = nodes.map(
//     (node) =>
//       baseApi
//         .get(
//           `portal/get-new-cms-data/hubzuweb?template=/hubzuweb/pages/${node}`
//         )
//         .then((res) => ({ [node]: res.data }))
//         .catch(() => ({ [node]: null })) // safe fallback
//   );
//   const results = await Promise.all(requests);
//   return Object.assign({}, ...results);
// };
